<template>
  <div class="sm:max-w-3xl mx-auto">
    <transition name="fade" mode="out-in">
      <div class="card mb-5" v-if="resource.ready">
        <div class="card-title flex justify-between" v-once>
          <div>Лог инструмента – {{ entry.product.name }}</div>
        </div>

        <form class="spaced-y-4">
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Порядковый номер"
                v-model="entry.id"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Инструмент"
                v-model="entry.product.name"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Серийный номер"
                v-model="entry.product.unique_id"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Покупатель"
                :value="`${entry.customer.full_name} (${entry.customer.phone})`"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Стоимость инструмента"
                v-model="entry.amount"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Чехол"
                :value="entry.case ? entry.case.name : ''"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Стоимость чехла"
                :value="entry.case_amount"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Общая сумма сделки"
                :value="entry.total_amount"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Продавец"
                :value="entry.seller ? entry.seller.full_name : ''"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Откуда узнал"
                :value="entry.from_who_note"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Кот"
                :value="entry.partner ? entry.partner.full_name : ''"
                disabled
            />
          </div>
          <div class="flex -mx-2">
            <text-field
                class="w-full px-2"
                title="Положение денег"
                :value="entry.account ? entry.account.name : ''"
                disabled
            />
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";

export default {
  extends: ResourceForm,

  data() {
    return {
      resource: {
        name: "admin.billing.orders",
        endpoint: "admin/billing/orders",
      },


      selects: {
        ready: false
      }
    };
  }
};
</script>
